<template>
  <el-menu :default-openeds="defaultOpeneds"
           :default-active="defaultActive"
           @select="handelSelect">
    <!-- <el-submenu index="1">
      <template slot="title"><i class="el-icon-message"></i>导航一</template> -->
    <el-menu-item :index="item.index"
                  v-for="(item) in menueData"
                  @click="routeTo(item.routeName)"
                  :key="item.index"> <i :class="item.icon"
         class="menue-icon"></i>
      <span slot="title">{{item.label}}</span>
    </el-menu-item>
    <!-- </el-submenu> -->
  </el-menu>
</template>

<script>
import { parseTime } from '@/utils'
export default {
  name: 'AsideMenue',
  data() {
    return {
      defaultOpeneds: ['1'], //['1', '3']
      //   defaultActive: '1-1',
      menueData: [
        // {
        //   index: '1-1',
        //   label: this.$t('menue.find'),
        //   routeName: 'lifeDiscovery',
        //   icon: 'el-icon-s-opportunity',
        // },
        {
          index: '1-2',
          label: this.$t('menue.detail'),
          routeName: 'search',
          icon: 'iconfont icon-sousuo1',
        },
        // {
        //   index: '1-3',
        //   label: this.$t('menue.customized'),
        //   routeName: 'customized',
        //   icon: 'iconfont icon-dingzhi',
        // },
        {
          index: '1-4',
          label: this.$t('menue.porj'),
          routeName: 'loadProject',
          icon: 'iconfont icon-baocun',
        },
        {
          index: '1-5',
          label: this.$t('menue.custom'),
          routeName: 'customManage',
          icon: 'el-icon-s-custom',
        },
        // {
        //   index: '1-6',
        //   label: 'selector',
        //   routeName: 'selector',
        //   icon: 'el-icon-setting',
        // },
        // {
        //   index: '1-3',
        //   label: 'home',
        //   routeName: 'Home',
        //   icon: 'el-icon-setting',
        // },
        /*// {
        //   index: '1-3',
        //   label: 'wordcloud',
        //   routeName: 'wordcloud',
        //   icon: 'el-icon-setting',
        // },
        {
          index: '1-4',
          label: 'Echarts',
          routeName: 'Echarts',
          icon: 'el-icon-setting',
        },
        {
          index: '1-5',
          label: 'mixEcharts',
          routeName: 'mixEcharts',
          icon: 'el-icon-setting',
        },
        {
          index: '1-6',
          label: 'selector',
          routeName: 'selector',
          icon: 'el-icon-setting',
        },
        {
          index: '1-7',
          label: 'datatableExample',
          routeName: 'datatableExample',
          icon: 'el-icon-setting',
        },
        // {
        //   index: '1-8',
        //   label: 'DatatableExampleTwo',
        //   routeName: 'DatatableExampleTwo',
        //   icon: 'el-icon-setting',
        // },
        {
          index: '1-9',
          label: 'EchartAndTableExample',
          routeName: 'EchartAndTableExample',
          icon: 'el-icon-setting',
        },*/
      ],
    }
  },
  methods: {
    routeTo(routeName) {
      this.$router.push({
        name: routeName,
        query: {
          plat: '',
          brand_id: '',
          start: parseTime(this.$store.state.user.startMonth, '{y}-{m}-{d}'),
          end: parseTime(this.$store.state.user.endMonth, '{y}-{m}-{d}'),
          word: '',
          cat_id: '',
          cat_name: '',
        },
      })
      //   let org_end = localStorage.getItem('defaultEndMonth')
      //   this.$store.dispatch('user/changeCatName', '')
      //   this.$store.dispatch('user/changeCatId', '')
      //   this.$store.dispatch('user/changeSelectedType', [])
      //   this.$store.dispatch('user/changeBrandName', [])
      //   this.$store.dispatch('user/changeselectedKeyWords', '')
      //   this.$store.dispatch('user/changeStartMonth', org_end)
      //   this.$store.dispatch('user/changeEndMonth', org_end)
      //   this.$store.dispatch('user/changeplants', ['douyin', 'weibo', 'xhs'])
      //   this.$store.dispatch('user/changeKolType', ['consumer', 'kol'])
      //   this.$store.dispatch('user/changeKolId', '')
      //   this.$store.dispatch('user/changeKolName', '')
      //   this.$store.dispatch('user/changePostKolId', '')
      //   this.$store.dispatch('user/changePostKolName', '')
      //   this.$store.dispatch('user/changeAnalyseTyp', '')
      //   this.$store.dispatch('user/changeRouterAnalyseTyp', '')
      //   this.$store.dispatch('user/changeWords', '')
      //   this.$store.dispatch('user/changeLabelLevel', '')
      //   this.$store.dispatch('user/changeAspectType', '')
      //   this.$store.dispatch('user/changeRuleId', '')
      //   this.$store.dispatch('user/changeRouterRuleId', '')
      //   this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
    },
    handelSelect(index) {
      this.$store.dispatch('user/changeActivedMnenue', index)
    },
  },
  computed: {
    defaultActive() {
      // return this.$store.state.user.ActivedMnenue
      let index = '1-1'
      let routeName = this.$route.name,
        matchItem = null
      if (routeName) {
        // index = this.menueData.find((item) => {
        //   return item.routeName == this.$route.name
        // }).index
        matchItem = this.menueData.find((item) => {
          return item.routeName == this.$route.name
        })
        if (matchItem) {
          index = matchItem.index
        }
        if (routeName == 'detail') {
          index = '1-2'
        }
      }
      return index
    },
  },
}
</script>

<style scoped>
.el-icon-s-custom {
  width: 18px !important;
}
</style>